import './base';

import './softwear';

import './configs';
import './directives';
import './filters';
import './services';
